import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { StingrayCommonModule } from '@modules/common/common.module';
import { DashboardActionsComponent } from '@modules/dashboard/components/dashboard-actions/dashboard-actions.component';
import { DashboardDetailGridModalComponent } from '@modules/dashboard/components/dashboard-detail-grid-modal/dashboard-detail-grid-modal.component';
import { DashboardGaugeChartComponent } from '@modules/dashboard/components/dashboard-gauge-chart/dashboard-gauge-chart.component';
import { DashboardMultiGaugeGraphDetailsPerRowComponent } from '@modules/dashboard/components/dashboard-multi-gauge-graph-details-per-row/dashboard-multi-gauge-graph-details-per-row';
import { DashboardSingleGroupTileDetailsPerRowComponent } from '@modules/dashboard/components/dashboard-single-group-tile-details-per-row/dashboard-single-group-tile-details-per-row.component';
import { DashboardSingleGroupTileDetailsPerTileComponent } from '@modules/dashboard/components/dashboard-single-group-tile-details-per-tile/dashboard-single-group-tile-details-per-tile.component';
import { DashboardTileLoadingComponent } from '@modules/dashboard/components/dashboard-tile-loading/dashboard-tile-loading.component';
import { DashboardComponent } from '@modules/dashboard/components/dashboard/dashboard.component';
import { DASHBOARD_ROUTES } from '@modules/dashboard/dashboard.routes';

@NgModule({
    declarations: [
        DashboardSingleGroupTileDetailsPerRowComponent,
        DashboardSingleGroupTileDetailsPerTileComponent,
        DashboardMultiGaugeGraphDetailsPerRowComponent,
        DashboardComponent,
        DashboardActionsComponent,
        DashboardGaugeChartComponent,
        DashboardTileLoadingComponent,
        DashboardDetailGridModalComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatIconModule,
        MatBadgeModule,
        MatToolbarModule,
        MatSidenavModule,
        MatGridListModule,
        MatCardModule,
        MatDividerModule,
        MatListModule,
        MatTableModule,
        MatFormFieldModule,
        MatInputModule,
        MatTooltipModule,
        MatDialogModule,
        StingrayCommonModule,
        RouterModule.forChild(DASHBOARD_ROUTES)
    ]
})
export class DashboardModule { }
